type Translate = (key: string) => string;

/** Converts gateway failures into stable, user-facing copy without exposing implementation details. */
export function getInsightsErrorMessage(
    errorCode: string | null | undefined,
    error: string | null | undefined,
    t: Translate,
): string {
    const signal = `${errorCode ?? ''} ${error ?? ''}`.toUpperCase();

    if (/CONFIDENTIAL|THRESHOLD|INSUFFICIENT_RESPONSES|TOO_FEW_RESPONSES/.test(signal))
        return t('managerAssessmentEvaluation.insights.belowConfidentialityThreshold');
    if (
        /NO_RESPONSES|NO RESPONSES|NO SURVEY DATA|NO_SURVEY_DATA|NO_DATA|INSUFFICIENT_DATA|RESPONSES_NOT_FOUND/.test(
            signal,
        )
    )
        return t('managerAssessmentEvaluation.insights.noResponses');
    if (/TIMEOUT|TIMED_OUT|SERVICE_UNAVAILABLE|AI_UNAVAILABLE|GATEWAY_UNAVAILABLE/.test(signal))
        return t('managerAssessmentEvaluation.insights.serviceUnavailable');
    if (/INVALID_AI_RESPONSE|INVALID_OUTPUT|UNUSABLE|MALFORMED_OUTPUT/.test(signal))
        return t('managerAssessmentEvaluation.insights.unusableOutput');

    return t('managerAssessmentEvaluation.insights.unexpectedError');
}
